/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tracking': {
    width: 15,
    height: 20,
    viewBox: '0 0 15 20',
    data: '<g transform="translate(.5 -2)" _fill="none" fill-rule="evenodd"><path pid="0" d="M12.253 4.182a5.707 5.707 0 0 1 0 8.07l-4.036 4.036-4.035-4.035a5.707 5.707 0 1 1 8.07-8.07zM5.504 13.778c-3.128 0-4.692.595-4.692 1.785 0 1.372 1.302 1.785 4.692 1.785M4.505 17.348c3.128 0 4.692.595 4.692 1.785 0 1.371-1.302 1.785-4.692 1.785" _stroke="#234357"/><circle pid="1" _stroke="#008AFF" cx="8.217" cy="7.689" r="1.44"/></g>'
  }
})
